export function filterArrayOfObjectsDuplicates<T, K extends keyof T>(
	array: Array<T>,
	key: K,
) {
	return array.filter(
		(item, idx, arr) =>
			arr.findIndex((itemToCheck) => item[key] === itemToCheck[key]) === idx,
	);
}
